import React from "react";
import { useQuery } from "@apollo/client";
import { LISTING_FAQS_QUERY } from "../graphql/faqs";
import FaqAccordion from "./FaqAccordion";

type Faq = { id: string; question: string; answer: string; position: number };
type ListingFaqsData = { listingFaqs: Faq[] };

type Props = {
  productType: string;
  metal?: string;
  headingLabel: string;
};

export default function ListingFaqSection({
  productType,
  metal,
  headingLabel,
}: Props) {
  const { data } = useQuery<ListingFaqsData>(LISTING_FAQS_QUERY, {
    variables: { productType, metal: metal || null },
    fetchPolicy: "cache-and-network",
    skip: !productType,
  });

  const faqs = data?.listingFaqs ?? [];
  if (!faqs.length) return null;

  return (
    <FaqAccordion
      faqs={faqs}
      title={`${headingLabel} — Frequently Asked Questions`}
    />
  );
}
